import { motion, AnimatePresence } from "framer-motion";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import React from "react";
import * as styles from "./HamburgerMenu.module.css";

export default function HamburgerMenu({ navItems, logo, socialMedia }) {
  const [open, setOpen] = React.useState(false);
  return (
    <main className={styles.wrapper}>
      <section className={styles.barContainer}>
        <span>
          {logo &&
            logo.map((logo, index) => (
              <a
                key={index}
                href={logo.href ? logo.link : null}
                aria-label={logo.alt}
              >
                <GatsbyImage
                  image={getImage(logo.image.asset)}
                  alt={logo.alt}
                  className={styles.logo}
                />
              </a>
            ))}
        </span>
        <button
          aria-label="Open Navigation"
          className={styles.hamburgerButton}
          onClick={() => setOpen(!open)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="2"
            stroke="var(--white)"
            name="menu icon"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
            />
          </svg>
        </button>
      </section>
      <AnimatePresence mode="wait">
        {open && (
          <motion.section
            key={"container"}
            initial={{ opacity: 0, x: 330 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 1, width: 0 }}
            transition={{ duration: 0.3 }}
            className={open ? styles.openContainer : styles.closedContainer}
            style={{ display: open ? "block" : "none" }}
          >
            <span className={styles.innerContainer} key={"innerContainer"}>
              {navItems.map((item, index) =>
                item.link.substring(0, 1) === "/" ? (
                  <Link to={item.link} key={index} aria-label={item.name}>
                    <motion.p
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -20 }}
                      transition={{ duration: 0.5, delay: 0.1 }}
                      className={styles.link}
                      aria-label={item.name}
                    >
                      {item.name}
                    </motion.p>
                  </Link>
                ) : (
                  <motion.a
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -20 }}
                    transition={{ duration: 0.5, delay: 0.1 }}
                    href={item.link}
                    target="_blank"
                    rel="noreferrer"
                    key={index}
                    aria-label={item.name}
                  >
                    <p className={styles.link} aria-label={item.name}>
                      {item.name}
                    </p>
                  </motion.a>
                )
              )}
              <span
                className={styles.socialMediaContainer}
                key={"socialMediaContainer"}
              >
                {socialMedia &&
                  socialMedia.map((social, index) => (
                    <motion.a
                      initial={{ opacity: 0, x: -30 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.5 }}
                      aria-label={social.alt}
                      key={index}
                      href={social.Link}
                      target="_blank"
                      rel="noreferrer"
                      alt={social.alt}
                    >
                      <GatsbyImage
                        className={styles.socialMediaIcon}
                        image={social.Icon.asset.gatsbyImageData}
                        alt={social.alt}
                      />
                    </motion.a>
                  ))}
              </span>
            </span>
          </motion.section>
        )}
      </AnimatePresence>
    </main>
  );
}
